import type { Batch, BatchStatus } from '@ctcells/contract'
import { t } from '@ctcells/i18n'

/**
 * **복구 줄의 세 판정(재개 · 폐기 · 완료 확정 — 확인 재개 포함)을 서버가 받는 배치 상태.**
 *
 * 🔴 계약 원문(`recoverBatch` 설명 · 실서버 0.28.15 생성 타입): 「받는 배치 상태 — `paused`·`error` 는 모든 decision ·
 *    `aborted`(시작 뒤 중단 · 종착 후 처분)는 `discard_samples`·`rerun_samples` 만 · 그 밖은 409 `BATCH_COMMAND_NOT_ALLOWED`」.
 *    core `services/batches.py` `FROM_RECOVER = (paused, error)` · `FROM_SETTLE_TERMINAL = (aborted,)` 와 같다.
 * ⚠ **왜 이 표가 필요한가** — 끝난 작업에 처분할 시료가 남으면 서버가 `allowed_commands` 에 `recover` 를 싣는다(종착 처분용).
 *   그 `recover` 하나로 세 판정을 켜면 눌러도 409 `reason: state` 다(2026-10-24 실측 · `8f62f5d9` aborted 에 resume · discard ·
 *   confirm_completed · rerun_cut_atom 전부 409). 서버가 판정마다 받는지 알리는 칸이 없어 계약 문장을 옮겼다 — 상태를 추론하는 게
 *   아니라 서버 `status` 를 서버 규칙에 맞댄다. 활성은 그래도 `allowed_commands` 가 먼저 정한다(이 표는 끄기만 한다).
 */
export const RECOVER_DECISION_STATUSES: readonly BatchStatus[] = ['paused', 'error']

/**
 * 그 작업에 복구 › 재개 · 폐기 · 완료 확정을 서버가 받지 않으면 사유, 받으면 `undefined`.
 * 이송 격리가 남은 끝난 작업(`review_reason=handoff_unconfirmed`)이면 [트레이 자리 정리]를 먼저 하라고 말한다 —
 * 격리가 풀리면 서버가 까닭을 `sample_disposition` 으로 바꿔 [시료 처분]이 선다.
 */
export function recoverDecisionRefusal(
  batch: Pick<Batch, 'status' | 'review_reason'>,
): string | undefined {
  if (RECOVER_DECISION_STATUSES.includes(batch.status)) return undefined
  if (batch.status === 'aborted' || batch.status === 'completed')
    return batch.review_reason === 'handoff_unconfirmed'
      ? t('reason.recoverEndedHandoff')
      : t('reason.recoverEnded')
  return undefined
}
